export default "__VITE_ASSET__1a92ac6a__"